__turbopack_context__.v({
  "default": "search-field-module-scss-module__UQQyhq__default",
  "dense": "search-field-module-scss-module__UQQyhq__dense",
  "end-icon": "search-field-module-scss-module__UQQyhq__end-icon",
  "full-width": "search-field-module-scss-module__UQQyhq__full-width",
  "input": "search-field-module-scss-module__UQQyhq__input",
  "input-wrapper": "search-field-module-scss-module__UQQyhq__input-wrapper",
  "mid": "search-field-module-scss-module__UQQyhq__mid",
  "normal": "search-field-module-scss-module__UQQyhq__normal",
  "round": "search-field-module-scss-module__UQQyhq__round",
  "search-field": "search-field-module-scss-module__UQQyhq__search-field",
  "start-icon": "search-field-module-scss-module__UQQyhq__start-icon",
  "submit-button": "search-field-module-scss-module__UQQyhq__submit-button",
  "transparent": "search-field-module-scss-module__UQQyhq__transparent",
  "white": "search-field-module-scss-module__UQQyhq__white",
});
